<ie-message></ie-message>
<div class="page-margin quote-lookup">
    <header class="logo-header">
        <logo></logo>
    </header>
    <article>
        <h1>Form Complete Demo</h1>
        <form id="f3757f6e-bd3b-47a8-8c74-d280cad007f3" form-id="f3757f6e-bd3b-47a8-8c74-d280cad007f3" (ngSubmit)="onSubmit()">
            <div class="input-field">
                <label for="email">Email<span class="req">*</span></label>
                <input type="text"
                    input-name="email"
                    id="email"
                    name="email"
                    placeholder="Email"
                    [(ngModel)]="email"
                    required />
                <input type="text"
                    input-name="first-name"
                    id="first-name"
                    name="first-name"
                    placeholder="First Name"
                    [(ngModel)]="firstName"
                    required />
                <input type="text"
                    input-name="last-name"
                    id="last-name"
                    name="last-name"
                    placeholder="Last Name"
                    [(ngModel)]="lastName"
                    required />
                <input type="text"
                    input-name="company"
                    id="company"
                    name="company"
                    placeholder="Company"
                    [(ngModel)]="company"
                    required />
            </div>

            <h5>Form Details:</h5>
            <div class="form-details">
                <p><strong>Email:</strong> {{ email }}</p>
                <p><strong>First Name:</strong> {{ firstName }}</p>
                <p><strong>Last Name:</strong> {{ lastName }}</p>
                <p><strong>Company:</strong> {{ company }}</p>
            </div>

            <button class="button" type="submit">Submit</button>
        </form>
    </article>
</div>